import React from 'react';
import { motion } from 'framer-motion';
import { HeartHandshake, Car, Languages } from 'lucide-react';
import { Button } from '../ui/Button';

export const Support: React.FC = () => {
    const scrollToContact = () => {
        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section className="py-20 md:py-32 bg-white">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16 md:mb-20">
                     <span className="text-[#11BC97] font-bold tracking-widest uppercase text-xs md:text-sm mb-4 block flex items-center justify-center gap-2">
                        <span className="w-8 h-[1px] bg-[#11BC97]"></span>
                        Assistance
                         <span className="w-8 h-[1px] bg-[#11BC97]"></span>
                    </span>
                    <h2 className="text-3xl md:text-5xl font-bold mb-6">We've Got You Covered</h2>
                    <p className="text-gray-500 max-w-2xl mx-auto text-base md:text-lg">A range of services to help you every step of the way.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Feature 1: The Buddy */}
                    <motion.div 
                        whileHover={{ y: -10 }}
                        className="bg-white p-8 md:p-10 rounded-[2.5rem] border border-gray-100 shadow-xl shadow-gray-100/50 flex flex-col items-center text-center group"
                    >
                        <div className="w-20 h-20 bg-[#11BC97]/10 rounded-full flex items-center justify-center mb-8 group-hover:bg-[#11BC97] transition-colors duration-300">
                            <HeartHandshake className="w-10 h-10 text-[#11BC97] group-hover:text-white transition-colors" />
                        </div>
                        <h3 className="text-xl md:text-2xl font-bold mb-4">Personal Caregiver</h3>
                        <p className="text-gray-500 leading-relaxed text-sm md:text-base">
                            On arrival, you’ll be paired with a personal, English-speaking 'buddy'. They act as your advocate, 
                            relaying questions to the team and ensuring your requests are answered quickly.
                        </p>
                    </motion.div>

                    {/* Feature 2: Transport & Leisure */}
                    <motion.div 
                         whileHover={{ y: -10 }}
                        className="bg-[#11BC97] p-8 md:p-10 rounded-[2.5rem] shadow-xl shadow-[#11BC97]/20 flex flex-col items-center text-center text-white"
                    >
                        <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mb-8 backdrop-blur-sm">
                            <Car className="w-10 h-10 text-white" />
                        </div>
                        <h3 className="text-xl md:text-2xl font-bold mb-4">VIP Transport</h3>
                        <p className="text-white/90 leading-relaxed text-sm md:text-base">
                            We arrange transport to all clinical appointments. Want to explore Istanbul? 
                            Your buddy can help you visit must-see attractions and award-winning restaurants.
                        </p>
                    </motion.div>

                    {/* Feature 3: Translation */}
                    <motion.div 
                         whileHover={{ y: -10 }}
                        className="bg-white p-8 md:p-10 rounded-[2.5rem] border border-gray-100 shadow-xl shadow-gray-100/50 flex flex-col items-center text-center group"
                    >
                        <div className="w-20 h-20 bg-[#11BC97]/10 rounded-full flex items-center justify-center mb-8 group-hover:bg-[#11BC97] transition-colors duration-300">
                            <Languages className="w-10 h-10 text-[#11BC97] group-hover:text-white transition-colors" />
                        </div>
                        <h3 className="text-xl md:text-2xl font-bold mb-4">Translation Services</h3>
                        <p className="text-gray-500 leading-relaxed text-sm md:text-base">
                            If your first language isn’t English or Turkish, don’t worry. We have a network of translators 
                            who can provide translation services at your appointments.
                        </p>
                    </motion.div>
                </div>
                
                <div className="mt-16 text-center">
                    <Button variant="outline" onClick={scrollToContact}>Talk to Support</Button>
                </div>
            </div>
        </section>
    );
};